import { ShaderModule } from '@luma.gl/shadertools';

export const globeHorizonClipModule = {
    name: 'hide-opposite-globe',
    inject: {
        'vs:#main-end': `
        if (project.projectionMode == PROJECTION_MODE_GLOBE &&  project.scale < 256.0) {
            vec3 anchorCommon = project_position(instancePositions, instancePositions64Low);
            vec3 cam = project.cameraPosition;
            if (dot(anchorCommon, cam - anchorCommon) <= 0.0) {
                gl_Position = vec4(0.0);
            }
        }
        `
    }
} satisfies ShaderModule;
